import {useMutation, useQueryClient} from "@tanstack/react-query";
import {ProjectResType} from "../interface";
import {createProjectApi,} from "../../../../api/correspondent/projectApi";
import useGoToNavigation from "../../../../util/useGotoNavigation";
import {useModal} from "../../../../hooks";

/**
 * 프로젝트 생성
 * @param props
 * @returns
 */
export const useCreateProject = (afterCallback: any) => {
    const qc = useQueryClient()
    const {goToNavigation} = useGoToNavigation()
    const {handleModal} = useModal()

    const {mutate} = useMutation({
        mutationFn: (data: ProjectResType) => createProjectApi(data),
        onSuccess: (res) => {
            if (res.code === "0000") {
                handleModal({
                    isOpen: true,
                    contents: "저장되었습니다.",
                    type: "alert",
                    closeAction: () => {
                        afterCallback()
                        const projectId = res.result.projectId;
                        goToNavigation(`customer/project/detail/${projectId}`, {}, false)
                        qc.invalidateQueries({queryKey: ["readProjectDetail", projectId]})
                    }
                })
            } else {
                handleModal({
                    isOpen: true,
                    contents: res.msg,
                    type: "alert",
                })
            }
        },
        onError: (err) => {
            console.log(err);
        },
    });

    return {mutate};
};
